import { useNavigate } from 'react-router-dom'
import { LoginButton } from '@/pages/LandingPage'

export const BlogPage = () => {
  const navigate = useNavigate()

  return (
    <div className="lp-root">
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <div className="lp-nav-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <span>GEO Writer</span>
            <span className="lp-nav-logo-dot">.</span>
          </div>
          <div className="lp-nav-links">
            <a href="/" className="lp-nav-link">Home</a>
            <a href="/blog" className="lp-nav-link" style={{ fontWeight: 600, color: '#111' }}>Blog</a>
          </div>
          <div className="lp-nav-actions">
            <LoginButton className="lp-nav-signin">Sign In</LoginButton>
            <LoginButton className="lp-nav-cta">Get Started</LoginButton>
          </div>
        </div>
      </nav>

      <section style={{ maxWidth: 720, margin: '120px auto 80px', padding: '0 40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: 36, fontWeight: 700, letterSpacing: '-0.03em', marginBottom: 16 }}>Blog</h1>
        <p style={{ fontSize: 16, color: '#666', lineHeight: 1.6 }}>
          Coming soon — insights on Generative Engine Optimization, AI visibility, and content strategy.
        </p>
      </section>

      <footer className="lp-footer">
        <div className="lp-footer-bottom">
          <p>&copy; 2026 Wisflow Technology Limited. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}
